import { render, staticRenderFns } from "./product-filter-card.vue?vue&type=template&id=24d49ca8&scoped=true"
import script from "./product-filter-card.vue?vue&type=script&lang=js"
export * from "./product-filter-card.vue?vue&type=script&lang=js"
import style0 from "./product-filter-card.vue?vue&type=style&index=0&id=24d49ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d49ca8",
  null
  
)

export default component.exports